<div class="d-flex w-100">
	<div class="ms-auto">
		<p-button pRipple styleClass="p-button-raised p-button-primary m-2" (click)="newPaymentProfile = true">
			<ng-template pTemplate="content">
				<div class="d-flex justify-content-center">
					<fa-icon [icon]="['far', 'plus']" size="lg" class="ms-1 me-2"></fa-icon>
					New Payment Profile
				</div>
			</ng-template>
		</p-button>
	</div>
</div>
<div class="d-flex flex-wrap">
	<ng-container *ngFor="let profile of venueService.venueFinance.value.paymentProfiles">
		<div class="col-4">
			<div class="card m-2 h-100">
				<div class="d-flex flex-column">
					<div class="display-11 ms-1 mt-2 mb-1 w-100">
						<div class="p-grid">
							<div class="col-6 d-flex">
								<div class="">
									<fa-icon [icon]="['fab', 'cc-visa']" *ngIf="profile.creditCardType === 'Visa'" size="lg"></fa-icon>
									<fa-icon [icon]="['fab', 'cc-amex']" *ngIf="profile.creditCardType === 'Amex'" size="lg"></fa-icon>
									<fa-icon [icon]="['fab', 'cc-mastercard']" *ngIf="profile.creditCardType === 'MasterCard'" size="lg"></fa-icon>
									<fa-icon [icon]="['fab', 'cc-discover']" *ngIf="profile.creditCardType === 'Discover'" size="lg"></fa-icon>
									<fa-icon [icon]="['far', 'money-check-dollar-pen']" *ngIf="profile.profilePaymentType === 'eCheck'" size="lg"></fa-icon>
									<fa-icon
										[icon]="['far', 'credit-card-front']"
										*ngIf="
											(profile.creditCardType === 'Unknown' || profile.creditCardType === '' || !profile.creditCardType) &&
											profile.profilePaymentType !== 'eCheck'
										"
										size="lg"
									></fa-icon>
									<span *ngIf="profile.profilePaymentType === 'Credit Card'">
										{{ profile.creditCardNumber.substring(profile.creditCardNumber.length - 4, profile.creditCardNumber.length) }}
									</span>
									<span *ngIf="profile.profilePaymentType === 'eCheck'">
										{{ profile.bankAccountNumber.substring(profile.bankAccountNumber.length - 4, profile.bankAccountNumber.length) }}
									</span>
								</div>
							</div>
							<div class="col-6 d-flex">
								<div class="ms-auto" *ngIf="profile.profilePaymentType === 'Credit Card'">
									<span *ngIf="profile.creditCardDaysToExpiry > 0"
										>Exp {{ app.moment(profile.creditCardExpirationDate, "YYYY-MM-DD").format("MM/YY") }} ({{
											profile.creditCardDaysToExpiry
										}}
										days)</span
									>
									<span *ngIf="profile.creditCardDaysToExpiry < 0" class="text-danger">expired</span>
								</div>
							</div>
						</div>
					</div>
					<div class="ms-auto">
						<p-button
							*ngIf="!(profile.creditCardDaysToExpiry && profile.creditCardDaysToExpiry < 30)"
							[disabled]="profile.defaultProfile"
							pRipple
							styleClass="p-button-raised m-2 p-button-secondary"
							(click)="setProfileDefault(profile)"
						>
							<ng-template pTemplate="content">
								<div class="d-flex justify-content-center">
									<fa-icon *ngIf="profile.defaultProfile" [icon]="['far', 'check']" size="lg" class="ms-1 me-2"></fa-icon>
									<span *ngIf="profile.defaultProfile"> Default</span>
									<span *ngIf="!profile.defaultProfile"> Make Default</span>
								</div>
							</ng-template>
						</p-button>
					</div>
				</div>
			</div>
		</div>
	</ng-container>
</div>

<p-dialog
	*ngIf="newPaymentProfile"
	[(visible)]="newPaymentProfile"
	[breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
	[style]="{ width: '50vw', height: '80vh' }"
>
	<app-payment-profile-setup
		(completedRecordChange)="addNewProfile($event)"
		source="commandcenter"
		[venueName]="venueService.subscriptionVenue.value.name"
		(profileCompleteChange)="newPaymentProfile = false"
	></app-payment-profile-setup>
</p-dialog>
